module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle4"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch3",
      "id": "rch3"
    }
  }, [_c('b', [_vm._v("Impossible!")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('b', [_vm._v("They said it couldn’t be done…")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectio"
  }, [_c('span', {
    staticClass: "org"
  }, [_c('b', [_vm._v("BY STEAMSHIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1hb"
  }, [_vm._v("“How, sir, would you make a ship sail against the wind and currents by lighting a bonfire under her deck? I pray you, excuse me, I have not the time to listen to such nonsense.”"), _c('br'), _c('b', [_vm._v("Napoleon Bonaparte, when told of Robert Fulton’s steamboat (c. 1807)")])]), _vm._v(" "), _c('p', {
    staticClass: "sectio"
  }, [_c('span', {
    staticClass: "org"
  }, [_c('b', [_vm._v("BY TRAIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1hb"
  }, [_vm._v("“What can be more palpably absurd than the prospect held out of locomotives traveling twice as fast as stagecoaches?”"), _c('br'), _c('b', [_c('i', [_vm._v("The Quarterly Review")]), _vm._v(", 1825")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p19-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectio"
  }, [_c('span', {
    staticClass: "org"
  }, [_c('b', [_vm._v("BY AIRPLANE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1hb"
  }, [_vm._v("“Flight by machines heavier than air is unpractical and insignificant, if not utterly impossible….No possible combination of known substances, known forms of machinery, and known forms of force, can be united in a practical machine by which man shall fly long distances through the air…”"), _c('br'), _c('b', [_vm._v("Simon Newcomb, astronomer-director of U.S. Naval Observatory, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p19-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectio"
  }, [_c('span', {
    staticClass: "org"
  }, [_c('b', [_vm._v("BY SUBMARINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1hb"
  }, [_vm._v("“I must confess that my imagination refuses to see any sort of submarine doing anything but suffocating its crew and floundering at sea.”"), _c('br'), _c('b', [_vm._v("H. G. Wells (c. 1901)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cfa2d2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Chapter3.vue
// module id = 87
// module chunks = 0